/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClassifierResponse
 */
export interface ClassifierResponse {
    /**
     * 
     * @type {number}
     * @memberof ClassifierResponse
     */
    classifierId: number;
    /**
     * 
     * @type {string}
     * @memberof ClassifierResponse
     */
    classifierType: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ClassifierResponse
     */
    classifierParams: { [key: string]: any; };
}

/**
 * Check if a given object implements the ClassifierResponse interface.
 */
export function instanceOfClassifierResponse(value: object): value is ClassifierResponse {
    if (!('classifierId' in value) || value['classifierId'] === undefined) return false;
    if (!('classifierType' in value) || value['classifierType'] === undefined) return false;
    if (!('classifierParams' in value) || value['classifierParams'] === undefined) return false;
    return true;
}

export function ClassifierResponseFromJSON(json: any): ClassifierResponse {
    return ClassifierResponseFromJSONTyped(json, false);
}

export function ClassifierResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassifierResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'classifierId': json['classifier_id'],
        'classifierType': json['classifier_type'],
        'classifierParams': json['classifier_params'],
    };
}

export function ClassifierResponseToJSON(json: any): ClassifierResponse {
    return ClassifierResponseToJSONTyped(json, false);
}

export function ClassifierResponseToJSONTyped(value?: ClassifierResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classifier_id': value['classifierId'],
        'classifier_type': value['classifierType'],
        'classifier_params': value['classifierParams'],
    };
}

